import { render, staticRenderFns } from "./dlw.vue?vue&type=template&id=f70a00ac&scoped=true&"
var script = {}
import style0 from "./dlw.vue?vue&type=style&index=0&id=f70a00ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70a00ac",
  null
  
)

export default component.exports